import { useContext, useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../../zustand/auth.store";
import { SideBarContext } from "../../context/SideBarContext";
import { LogoutContext } from "../../context/LogoutContext";
import { RxHamburgerMenu } from "react-icons/rx";
import clsx from "clsx";

const _extractInitials = (val: string) => {
  const _first = val.split(" ")[0].slice(0, 1);
  const _second = val?.split(" ")[1]?.slice(0, 1);
  return `${_first.toLocaleUpperCase()}${_second && _second.toLocaleUpperCase()}`;
};

const DashboardHeader = ({ title = "" }: { title?: any }) => {
  const [isAvatarMenuOpen, setIsAvatarMenuOpen] = useState(false);
  const avatarMenuRef = useRef<HTMLDivElement>(null);
  const profile: any = useAuth((s) => s.profile);
  const role = useAuth((s) => s.role);
  const sideBar = useContext(SideBarContext);
  const logout: any = useContext(LogoutContext);
  const { pathname } = useLocation();

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (avatarMenuRef.current && !avatarMenuRef.current.contains(e.target as Node)) {
        setIsAvatarMenuOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <header className={clsx(pathname === "/personal-information" ? "h-20 w-full bg-white fixed top-0 z-50" : "h-20 w-full sticky top-0 z-50")}>
      <div className="md:px-6 pl-3 h-full flex justify-between items-center">
        <div className="flex items-center gap-2">
          {pathname === "/personal-information" && (
            <img src={"/logo.svg"} className={clsx("w-[50px]", "transition-[width]")} />
          )}
          <h3 className="text-[#464749] text-xl md:text-2xl font-semibold">{title}</h3>
        </div>

        <div className="flex items-center">
          <div className="flex items-center md:px-6">
            {role === "USER" && (
              <Link className="hidden md:block" to={"/help"}>
                <img src="/help_outline.svg" />
              </Link>
            )}

            <Link
              to={"/notification"}
              className="w-10 h-10 rounded-full bg-opacity-20 cursor-pointer bg-transparent flex justify-center items-center"
            >
              <img src="/notification.svg" className="h-6 w-6" />
            </Link>

            <div className="border-l border-[#A0A3A6] mx-3 border h-[30px]" />

            <div className="relative" ref={avatarMenuRef}>
              <button
                className="flex items-center gap-2"
                onClick={() => setIsAvatarMenuOpen((prev) => !prev)}
              >
                <span className="w-8 h-8 bg-[#464749] text-white text-xl font-medium rounded-full flex items-center justify-center">
                  {_extractInitials(`${profile?.firstName ?? "Admin"} `)}
                </span>
                <div className="hidden md:block text-left">
                  <h3 className="text-xs font-medium">
                    Hello, {profile?.firstName ?? "Admin"} {profile?.lastName ?? "Ajosquad"}
                  </h3>
                  <h5 className="text-[10px] text-[#5A5C5E]">Good day</h5>
                </div>
              </button>

              {isAvatarMenuOpen && (
                <div className="hidden md:block absolute right-0 top-full mt-2 w-44 bg-white rounded-lg shadow-lg border border-[#E5E5E5] z-50 overflow-hidden">
                  <Link
                    to="/account"
                    className="flex items-center gap-2 px-4 py-3 text-sm text-[#464749] hover:bg-[#F5F5F9]"
                    onClick={() => setIsAvatarMenuOpen(false)}
                  >
                    My Account
                  </Link>
                  <button
                    onClick={() => {
                      setIsAvatarMenuOpen(false);
                      logout?.toggleLogout();
                    }}
                    className="w-full text-left flex items-center gap-2 px-4 py-3 text-sm text-red-500 hover:bg-[#F5F5F9] border-t border-[#E5E5E5]"
                  >
                    Logout
                  </button>
                </div>
              )}
            </div>

            <button
              onClick={sideBar?.toggleSideBar}
              className="pr-3 pl-4 inline-block lg:hidden"
            >
              <RxHamburgerMenu size={30} />
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default DashboardHeader;
